const React = require("react");
const {MobXProviderContext} = require("mobx-react");
const {observer} = require("mobx-react");

function Injector(store_names) {

    return (WrappedComponent) => {

        observer(WrappedComponent);

        return class extends React.Component {
            static contextType = MobXProviderContext;

            constructor(props) {
                super(props);

                this.component = React.createRef();
            }


            get wrappedInstance() {
                return this.component.current;
            }

            get stores() {
                if (typeof (store_names) === 'string') {
                    store_names = [store_names];
                }

                if (store_names.length > 0) {
                    return store_names.reduce((carry, store_name) => {

                        if (typeof (this.props[store_name]) !== 'undefined') {
                            return carry;
                        }

                        if (typeof (this.context[store_name]) !== 'undefined') {
                            carry[store_name] = this.context[store_name];
                        } else {
                            carry[store_name] = {};
                        }

                        return carry;

                    }, {})
                }

                return {};
            }

            render() {
                return <WrappedComponent {...this.props} {...this.stores} ref={this.component}/>;
            }
        }
    }
}

module.exports = Injector;
